<template lang="html">
<div class="error">
  <code v-if="errorMsg !== ''">
    Error: {{ errorMsg }}
  </code>
</div>
</template>

<script>
export default {
  props: {
    errorMsg: {
      type: String,
      required: true
    }
  }
}
</script>
